<template>
  <modal :show.sync="openModal" @close="closeOnClick" no-close-on-backdrop>
    <template slot="header">
      <h2 class="subtitle">Edit Service Area</h2>
    </template>

    <div class="row mt-3 mb-3">
      <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-sm-12">
        <WSelect
          placeholder="Area"
          v-model="$v.area.polygon.$model"
          label="Area"
          v-bind:class="{ 'is-invalid': $v.area.polygon.$error }"
          :error="$v.area.polygon.$error ? `Enter an Area` : ''"
        >
          <el-option
            v-for="(item, index) in areas"
            :key="index"
            :label="item.code"
            :value="item._id"
          >
            <span class="d-block">{{ item.code }}</span>
            <span class="d-block" style="color: #8492a6">{{
              item.description
            }}</span>
          </el-option>
        </WSelect>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
        <BaseNumberInput
          v-model.number="$v.area.price.$model"
          label="Base Price x Area"
          placeholder="Base Price"
          class="input-append-2 with-prepend"
          :error="generateValidationMessage($v.area.price, 'Price')"
        >
          <template slot="prepend">{{ currencySymbol }}</template>
          <template slot="append">{{ currencyCode }}</template>
        </BaseNumberInput>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
        <BaseNumberInput
          v-model.number="$v.area.price_extra_km.$model"
          :label="`Price x extra ${localUnit}`"
          placeholder="Extra price"
          class="input-append-2 with-prepend"
          :error="generateValidationMessage($v.area.price_extra_km, 'Price')"
        >
          <template slot="prepend">{{ currencySymbol }}</template>
          <template slot="append">{{ currencyCode }}</template>
        </BaseNumberInput>
      </div>
    </div>

    <template slot="footer">
      <base-button
        type="outline-neutral mb-0"
        class="min-button"
        @click="closeOnClick()"
        >Close</base-button
      >

      <base-button
        type="primary ml-auto"
        class="min-button mb-0"
        @click="updateArea(area)"
        >Update</base-button
      >
    </template>
  </modal>
</template>

<script>
import WSelect from "@/components/Select";
import {
  required,
  decimal,
  numeric,
  requiredIf,
  minValue
} from "vuelidate/lib/validators";
import { generateValidationMessage } from "../../services/validation.service";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditAreaModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedArea: {
      type: Object
    },
    areas: {
      type: Array,
      default: () => []
    },
    currencySymbol: {
      type: String
    },
    currencyCode: {
      type: String
    },
    localUnit: {
      type: String
    }
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.openModal = current;
      },
      deep: true
    },
    selectedArea: {
      handler: function(current, old) {
        if (current) {
          this.area = {
            price: current.price,
            polygon: current.polygon,
            price_extra_km: current.price_extra_km
          };
        }
      },
      deep: true
    }
  },
  data() {
    return {
      openModal: false,
      area: {
        price: "",
        polygon: "",
        price_extra_km: ""
      }
    };
  },
  created() {},
  methods: {
    generateValidationMessage,
    closeOnClick() {
      this.$emit("closeEditAreaModal", false);
      this.clearArea();
      this.openModal = false;
    },
    updateArea(area) {
      if (!this.$v.area.$invalid) {
        this.$emit("updateArea", this.area);
        this.clearArea();
        this.openModal = false;
      } else {
        this.$v.area.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    clearArea() {
      this.area = {
        price: "",
        polygon: "",
        price_extra_km: ""
      };
      this.$v.$reset();
    }
  },
  computed: {},
  components: {
    WSelect
  },
  validations: {
    area: {
      price: {
        required,
        decimal,
        minValue: minValue(1)
      },
      polygon: {
        required
      },
      price_extra_km: {
        required,
        decimal,
        minValue: minValue(1)
      }
    }
  }
};
</script>
